import { Empty } from 'antd';

import { Table } from '@atom/table/table';
import { Title } from '@atom/typography/typography';

import { useConsumerCredentials } from './consumer-credentials.hook';
import { consumerCredentialColumns } from './consumer-credentials.options';

export const ConsumerCredentials = () => {
  const { data, isLoading } = useConsumerCredentials();

  return (
    <>
      <Title level={3} mb={16} weight={400}>
        API Credentials
      </Title>
      <Table
        columns={consumerCredentialColumns}
        dataSource={data}
        loading={isLoading}
        locale={{ emptyText: <Empty description='No credentials' image={Empty.PRESENTED_IMAGE_SIMPLE} /> }}
        pagination={false}
        rowKey='id'
      />
    </>
  );
};
